import React from 'react';
import { LoginButton, TelegramAuthData } from '@telegram-auth/react';
import { OAuthButtonsProps } from '../types';
import { authenticateWithTelegram } from 'api/authApi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoginMethod, setUser } from 'store/slices/authSlice';
import toast from 'react-hot-toast';

const OAuthButtons: React.FC<OAuthButtonsProps> = ({
  isRegister,
  handleGoogleLogin,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleTelegramAuth = async (authData: TelegramAuthData) => {
    console.log(authData);
    try {
      const result = await authenticateWithTelegram(authData);
      console.log('API response:', result);
      if (result.success) {
        const { user_id, username, display_name, img_url, access_token } =
          result.data;
        dispatch(
          setUser({
            user: {
              userId: user_id,
              username,
              displayName: display_name,
              imgUrl: img_url,
              loginMethod: LoginMethod.TELEGRAM,
            },
            accessToken: access_token,
            telegramAuthData: authData,
          })
        );

        toast.success('Successfully logged in with Telegram!');
        navigate(-1);
      }
    } catch (error) {
      console.error('Error authenticating with Telegram:', error);
      toast.error('Failed to authenticate with Telegram. Please try again.');
    }
  };

  return (
    <div className='flex flex-col items-center justify-center'>
        <h4 className="w-full h-[18px] mt-4 text-secondaryNeutralAlpha-11 opacity-[62.75%] text-xs font-light">
            OR {isRegister ? "REGISTER" : "LOGIN"} WITH
        </h4>
        <div className="mt-3 max-w-[400px] flex flex-col gap-3">
            {/* Google Button */}
            <button 
                className="flex items-center justify-center gap-3 h-[42px] p-4 border border-secondaryNeutral-5 rounded-md bg-white hover:bg-gray-100 whitespace-nowrap"
                onClick={handleGoogleLogin} // Redirect to OAuth endpoint 
            >
                <img
                    src="/google.png"
                    alt="Google Logo"
                    className="h-6 w-6 bg-white"
                />
                <span className="text-base font-medium text-secondaryNeutral-12 opacity-[62.75%]">Continue with Google</span>
            </button>

            {/* Telegram Button */}       
            <div className="flex justify-center">
                <LoginButton
                  botUsername={process.env.REACT_APP_TELEGRAM_BOT_USERNAME || 'your_bot_username'} // Replace with your bot username from .env
                  onAuthCallback={handleTelegramAuth}
                  buttonSize="large" // "large" | "medium" | "small
                  cornerRadius={6} // 0 - 20
                />
            </div>
        </div>
    </div>
  );
};

export default React.memo(OAuthButtons);
